import { render } from "./DrawingBoard.vue?vue&type=template&id=2ad44e22&scoped=true"
import script from "./DrawingBoard.vue?vue&type=script&lang=js"
export * from "./DrawingBoard.vue?vue&type=script&lang=js"

import "./DrawingBoard.vue?vue&type=style&index=0&id=2ad44e22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad44e22"]])

export default __exports__